/*  ========================================================================
    # Components - Sections - Intro
    ========================================================================  */

// Dependencies
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

// Assets
import LogoRaiffeisen from "@images/svg/logos/logo-raiffeisen.svg";
import KeyvisualMobile from "@images/keyvisual-mobile.json";
import KeyvisualDesktop from "@images/keyvisual-desktop.json";
// import Participate from "@images/svg/ui/participate.svg";
import ArrowDown from "@images/svg/ui/arrow-down.svg";

const Intro = () => {
  const participateRef = useRef(null);
  const [participateFixed, setParticipateFixed] = useState(false);

  const animationMobile = useRef(null);
  const animationDesktop = useRef(null);

  const updateFixedState = useCallback(
    () =>
      setParticipateFixed(
        participateRef.current?.getBoundingClientRect().y <= 40
      ),
    [setParticipateFixed, participateRef]
  );

  useEffect(() => {
    updateFixedState(); // For initial page load.
    window.addEventListener("scroll", updateFixedState, {
      capture: true,
      passive: true,
    });
    return () => window.removeEventListener("scroll", updateFixedState);
  }, []);

  return (
    <section id="intro" className="s-intro">
      <a
        className="s-intro__logo-raiffeisen"
        href="https://www.raiffeisen-gesellschaft.de/"
        target="_blank"
        rel="noreferrer noopener"
      >
        <LogoRaiffeisen />
      </a>
      <Lottie
        className="s-intro__keyvisual s-intro__keyvisual--mobile"
        animationData={KeyvisualMobile}
        loop={false}
        lottieRef={animationMobile}
        onClick={() => animationMobile.current?.goToAndPlay(0)}
      />
      <Lottie
        className="s-intro__keyvisual s-intro__keyvisual--desktop"
        animationData={KeyvisualDesktop}
        loop={false}
        lottieRef={animationDesktop}
        onClick={() => animationDesktop.current?.goToAndPlay(0)}
      />
      {/* <div ref={participateRef} className="s-intro__container-participate">
        <Link
          ref={participateRef}
          className={`s-intro__link-participate ${
            participateFixed ? "fixed" : ""
          }`}
          to="/mitmachen"
        >
          <Participate />
        </Link>
      </div> */}
      <div className="container">
        <div className="s-intro__text">
          <p className="s-intro__prize">
            Gewinne bis zu 5.000 €
            <br />
            für deine Idee!
          </p>
          <h1>
            Raiffeisen-
            <br />
            Förderpreis 2025
          </h1>
          <h2>
            Deine Region. Dein Projekt.
            <br />
            <span className="u-text-orange">Deine Zukunft.</span>
          </h2>
          <a href="#what-is-it">
            <ArrowDown />
          </a>
          <h3 style={{ margin: "40px 0 0" }}>
            Die Einreichungsphase ist beendet.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Intro;
